export default "__VITE_ASSET__DjGHOQVv__"